export default __webpack_public_path__ + "static/media/headset.c2653491.svg";